/**
 * Um campo de senha nova, com a regra visível.
 *
 * A regra do Upgrade ID é 8 a 72 caracteres — 72 porque é o limite prático do
 * bcrypt, que ignora o que passa disso. Mostrar isso antes de enviar evita o
 * único erro de validação que a pessoa não tem como adivinhar.
 */
export function CampoDeSenha({ valor, onChange, placeholder = 'senha nova', autoComplete = 'new-password' }) {
  const curta = valor.length > 0 && valor.length < 8

  return (
    <div className="flex flex-col gap-1">
      <input
        type="password"
        required
        minLength={8}
        maxLength={72}
        value={valor}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
      />
      <span className={`text-[11px] ${curta ? 'text-amber-700' : 'text-zinc-400'}`}>
        {curta ? `faltam ${8 - valor.length} caracteres` : 'de 8 a 72 caracteres'}
      </span>
    </div>
  )
}

/**
 * Mensagem de erro vinda do Upgrade ID, traduzida.
 *
 * Os códigos dele são pensados para não ajudar quem está adivinhando, e por
 * isso não servem como texto de tela. Um código desconhecido cai numa frase
 * genérica em vez de aparecer cru — mas o console não inventa um motivo que
 * não sabe.
 */
const MENSAGENS = {
  invalid_credentials: 'A senha atual não confere.',
  nova_senha_igual_a_atual: 'A senha nova é igual à atual.',
  link_invalido: 'Este link não é válido. Peça um novo.',
  link_ja_usado: 'Este link já foi usado. Peça um novo.',
  link_expirado: 'Este link expirou. Peça um novo.',
  invalid_token: 'Sua sessão expirou. Entre de novo.',
  missing_bearer_token: 'Sua sessão expirou. Entre de novo.',
}

export function mensagemDeErro(erro) {
  const dados = erro?.response?.data
  const codigo = dados?.message

  if (erro?.response?.status === 429) {
    return 'Muitas tentativas em pouco tempo. Espere um minuto e tente de novo.'
  }
  if (typeof codigo === 'string' && MENSAGENS[codigo]) return MENSAGENS[codigo]

  // A validação devolve `details` com o campo e o problema; sem isso, quem vê
  // "validation_error" não descobre qual campo recusou.
  if (codigo === 'validation_error' && Array.isArray(dados?.details)) {
    return dados.details.map((d) => `${d.path}: ${d.message}`).join('\n')
  }
  return 'Não foi possível concluir. Tente de novo.'
}
